module.exports = __webpack_public_path__ + "2-52.jpg?408dc8512ae5a827c648050f623cac57";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-52.jpg
// module id = 129
// module chunks = 0